import { html } from 'lit';
import type { TemplateResult } from 'lit';

export function renderErrorPanel(downloadUrl: string, onRetry: () => void): TemplateResult {
  return html`
    <div class="error-panel" role="alert">
      <p>Couldn't load the demo.</p>
      <div class="error-actions">
        <button type="button" @click=${onRetry}>Retry</button>
        <a href=${downloadUrl} target="_blank" rel="noopener noreferrer">Download SoundApp</a>
      </div>
    </div>
  `;
}
